export default __webpack_public_path__ + "static/media/Bismillah.0b245d33.mp3";